import React, { useState, useEffect } from "react";

const ItemModal = ({
  formDetailList,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  onRowSelectItem02,
  showAddEmptyButton = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItemDataList, setFilteredItemDataList] =
    useState(itemDataList);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (showItemModal) {
      setSearchTerm("");
    }
  }, [showItemModal]);

  useEffect(() => {
    setFilteredItemDataList(
      itemDataList.filter(
        (item) =>
          item.Item_Code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.Item_Name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, itemDataList]);

  useEffect(() => {
    if (showItemModal) {
      setSearchTerm("");
      setSelectedItems([]); // ✅ เคลียร์รายการที่ถูกเลือกทุกครั้งที่เปิด
    }
  }, [showItemModal]);

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedItems(filteredItemDataList);
    } else {
      setSelectedItems([]);
    }
  };

  const handleCheckboxChange = (item) => {
    setSelectedItems((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.Item_Id === item.Item_Id
      );
      return isSelected
        ? prevSelected.filter((selected) => selected.Item_Id !== item.Item_Id)
        : [...prevSelected, item];
    });
  };

  const shouldShowAddEmptyButton = () => {
    return (
      showAddEmptyButton ||
      window.location.pathname === "/quotation" ||
      window.location.pathname === "/invoice" ||
      window.location.pathname === "/payment-voucher" ||
      window.location.pathname === "/product-receipt" ||
      window.location.pathname === "/credit-note" ||
      window.location.pathname === "/debit-note"
    );
  };

  return (
    <>
      <div
        className={`modal ${showItemModal ? "show" : ""}`}
        style={{ display: showItemModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">รายชื่อสินค้า</h5>
              <button type="button" className="close" onClick={handleItemClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="ค้นหา รหัสสินค้า หรือ ชื่อสินค้า"
                  value={searchTerm || ""}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div
                className="table-responsive"
                style={{ maxHeight: "450px", overflowY: "auto" }}
              >
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-center" style={{ width: "1%" }}>
                        <input
                          type="checkbox"
                          onChange={(e) => handleSelectAll(e.target.checked)}
                          checked={
                            filteredItemDataList.length > 0 &&
                            selectedItems.length === filteredItemDataList.length
                          }
                          style={{
                            width: "70px",
                            minWidth: "70px",
                            maxWidth: "70px",
                          }}
                        />
                      </th>
                      <th className="text-center" style={{ width: "14%" }}>
                        รหัสสินค้า
                      </th>
                      <th className="text-center" style={{ width: "45%" }}>
                        ชื่อสินค้า
                      </th>
                      <th className="text-center" style={{ width: "35%" }}>
                        Supplier
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItemDataList.length > 0 ? (
                      filteredItemDataList.map((item, index) => (
                        <tr
                          key={item.Item_Id || index + 1}
                          onClick={() => handleCheckboxChange(item)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: selectedItems.some(
                              (selectedItem) =>
                                selectedItem.Item_Id === item.Item_Id
                            )
                              ? "rgb(105, 188, 216)"
                              : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={selectedItems.some(
                                (selected) => selected.Item_Id === item.Item_Id
                              )}
                              onChange={() => handleCheckboxChange(item)}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                cursor: "pointer",
                                width: "70px",
                                minWidth: "70px",
                                maxWidth: "70px",
                                backgroundColor: selectedItems.some(
                                  (selected) =>
                                    selected.Item_Id === item.Item_Id
                                )
                                  ? "rgb(105, 188, 216)"
                                  : "transparent",
                                transition: "background-color 0.3s ease",
                              }}
                            />
                          </td>
                          <td className="text-center">{item.Item_Code}</td>
                          <td className="text-left">{item.Item_Name}</td>
                          <td className="text-left">{item.Item_Name_EN}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          ไม่พบข้อมูล
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              {shouldShowAddEmptyButton() && (
                <button
                  className="btn btn-primary"
                  onClick={() => onRowSelectItem02(selectedItems)}
                >
                  เพิ่มแบบไม่ระบุ
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => onRowSelectItem(selectedItems)}
                //disabled={selectedItems.length === 0} // คอมเม้นไว้ก่อน ใช้สำหรับ Disabled เมื่อยังไม่ได้เลือกสินค้า
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleItemClose}
              >
                ปิด
              </button>
            </div>
          </div>
        </div>
      </div>
      {showItemModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default ItemModal;
